/** Status vivo do Redis quando disponível; fallback no boolean para backend antigo. */
export const presenceOf = (u) => u?.presence ?? (u?.online ? 'online' : 'offline');

export const PRESENCE_LABELS = { online: 'Online', away: 'Ausente', offline: 'Offline' };

export const getInitials = (name = '') =>
  String(name || '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0])
    .join('')
    .toUpperCase();
